import { defineStore } from 'pinia';

export const useAppSettingsStore = defineStore({
    id: 'appSettingsStore',
    
    state()
    {
        return {
            // Analyst info
            analystTitle: "",
            analystFirstName: "",
            analystLastName: "",
            analystRole: "",
            analystPhone: "",
            analystAffiliation: "",
            analystAddress: "",
            analystPostcode: "",
            analystCity: "",
            analystState: "",
            analystCountry: "",
        };
    },

    getters: {
        analystFullName(): string
        {
            return `${this.analystFirstName} ${this.analystLastName}`
        },
    },
});
